// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.tellaw",
    name: "Tellaw Wallet",
    homepage: "https://www.tellaw.com/",
    image_id: "c1cb03f5-e1c2-4c3e-86e1-9a90565ea300",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id6446802245",
        android: "https://play.google.com/store/apps/details?id=com.tellaw.tellaw",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "tellaw://walletconnect",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map